import { isPlatformBrowser, NgFor } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import {
  CarouselComponent,
  CarouselControlComponent,
  CarouselIndicatorsComponent,
  CarouselInnerComponent,
  CarouselItemComponent,
  ThemeDirective
} from '@coreui/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-google-carousel',
  templateUrl: './google-carousel.component.html',
  styleUrl: './google-carousel.component.scss',
  imports: [
    ThemeDirective,
    CarouselComponent,
    CarouselIndicatorsComponent,
    CarouselInnerComponent,
    NgFor,
    CarouselItemComponent,
    CarouselControlComponent,
    TranslatePipe
  ]
})
export class GoogleCarouselComponent implements OnInit {
  @Input() slides: any[] = [
    {
      src: 'google.slides.image1.path.default',
      alt: 'google.slides.image1.alt',
      title: 'google.slides.image1.title',
      color: 'red'
    },
    {
      src: 'google.slides.image2.path.default',
      alt: 'google.slides.image2.alt',
      title: 'google.slides.image2.title',
      color: 'blue'
    },
    {
      src: 'google.slides.image3.path.default',
      alt: 'google.slides.image3.alt',
      title: 'google.slides.image3.title',
      color: 'green'
    },
    {
      src: 'google.slides.image4.path.default',
      alt: 'google.slides.image4.alt',
      title: 'google.slides.image4.title',
      color: 'yellow'
    }
  ];

  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.slides && this.slides.length > 0) {
      this.slides = [...this.slides];
    }
  }
}
